export default "__VITE_ASSET__XLnLMBU2__"